// ============================================================
// Breadcrumb Navigation
// ============================================================

import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { tokens } from '@/theme/tokens';

export function Breadcrumb({ items = [] }) {
  return (
    <Breadcrumbs
      separator={<ChevronRight size={14} color={tokens.colors.text.muted} />}
      sx={{ '& .MuiBreadcrumbs-li': { fontSize: tokens.typography.sizes.sm } }}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        if (isLast) {
          return (
            <Typography
              key={item.label}
              variant="body2"
              color="text.primary"
              fontWeight={500}
            >
              {item.label}
            </Typography>
          );
        }

        return (
          <Link
            key={item.label}
            component={RouterLink}
            to={item.path || '#'}
            underline="hover"
            color="text.secondary"
            sx={{
              fontSize: tokens.typography.sizes.sm,
              '&:hover': { color: tokens.colors.primary.main },
            }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
